var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('yandex-map',{attrs:{"coords":_vm.coords,"controls":_vm.controls,"zoom":_vm.zoom,"cluster-options":{
      1: {
        clusterDisableClickZoom: false,
        hasBalloon: false
      }
    }}},_vm._l((_vm.placemarks),function(placemark){return _c('ymap-marker',{key:placemark.node.nid,attrs:{"marker-id":placemark.node.nid,"marker-type":"placemark","coords":placemark.coords,"icon":{color: placemark.node.placemark_color, glyph: 'christian'},"hint-content":placemark.node.title,"callbacks":{click: function click() { _vm.clickMarker(placemark) }},"balloon-template":_vm.openBalloon(placemark),"cluster-name":"1"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }